import { generateId } from './generateId';

// ── Datenmodell ──────────────────────────────────────────────
export interface Schwachstelle {
  id: string;
  problem: string;
}

export interface Section4Data {
  schwachstellen: Schwachstelle[];
  fragestellungen: Array<{ text: string }>;
}

// ── Migration ──────────────────────────────────────────────────
export function migrateSchwachstelle(old: any): Schwachstelle {
  if (old.id && old.problem !== undefined) return { id: old.id, problem: old.problem };
  return {
    id: old.id || generateId(),
    problem: old.text || old.problem || '',
  };
}
